import { ListOptionsFormController } from '@shared/list-options/list-options-form.controller';

import { EMSP_BO_RFID_BADGE_ORDER_LIST_COLUMN_LABEL_I18N_KEY } from '../emsp-bo-rfid-badge-order-list/emsp-bo-rfid-badge-order-list.config';
import { useEmspBoRfidBadgeOrderListContext } from '../emsp-bo-rfid-badge-order.context';

export const EmspBoRfidBadgeOrderListOptionsController =
  (): React.JSX.Element => {
    const { columnOptions, setColumnOptions } =
      useEmspBoRfidBadgeOrderListContext();

    return (
      <ListOptionsFormController
        columnOptions={columnOptions}
        columnLabelMap={EMSP_BO_RFID_BADGE_ORDER_LIST_COLUMN_LABEL_I18N_KEY}
        onChange={setColumnOptions}
      />
    );
  };
